/* eslint-disable @angular-eslint/no-output-on-prefix */
import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, HostBinding } from '@angular/core';

@Component({
  standalone: true,
  selector: 'ups-pill-button',
  templateUrl: './pill-button.component.html',
  styleUrls: [ './pill-button.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { 
    class: 'd-flex pb-2' 
  }
})
export class RoundedPillButtonComponent {

  @HostBinding('class') @Input() public inline: 'responsive' | 'always' | ''  = '';
  @Input({ required: true }) public btns!: { text: string, value: string }[];
  @Input() public defaultIdx: number = 0;
  @Input() public fixWidth: boolean = false;
  @Output() protected onChange: EventEmitter<{ value: string, idx: number }> = new EventEmitter<{ value: string, idx: number }>();

  public click(idx: number): void{
    if (idx !== this.defaultIdx) {
      this.defaultIdx = idx;
      this.onChange.emit({ value: this.btns[idx].value, idx });
    }
  }
}
